module.exports = __webpack_public_path__ + "fonts/ApfelGrotezk-Regular.99b57525.woff2";